import { render, staticRenderFns } from "./CamposLivro.vue?vue&type=template&id=fc562bcc&scoped=true"
import script from "./CamposLivro.vue?vue&type=script&setup=true&lang=ts"
export * from "./CamposLivro.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CamposLivro.vue?vue&type=style&index=0&id=fc562bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc562bcc",
  null
  
)

export default component.exports